import { LayoutList, Columns3 } from 'lucide-react';

export default function ViewToggle({ view, onChange }) {
  return (
    <div className="flex bg-gray-100 dark:bg-gray-800 rounded-lg p-0.5">
      <button
        onClick={() => onChange('list')}
        className={`p-1.5 rounded-md transition-all ${
          view === 'list'
            ? 'bg-white dark:bg-gray-700 text-brand-600 dark:text-brand-400 shadow-sm'
            : 'text-gray-400 hover:text-gray-600 dark:hover:text-gray-300'
        }`}
      >
        <LayoutList size={16} />
      </button>
      <button
        onClick={() => onChange('kanban')}
        className={`p-1.5 rounded-md transition-all ${
          view === 'kanban'
            ? 'bg-white dark:bg-gray-700 text-brand-600 dark:text-brand-400 shadow-sm'
            : 'text-gray-400 hover:text-gray-600 dark:hover:text-gray-300'
        }`}
      >
        <Columns3 size={16} />
      </button>
    </div>
  );
}
